// pages/GuestOrderSuccess.jsx
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const GuestOrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  return (
    <div className="min-h-screen bg-[#f5f3ea] flex items-center justify-center px-4 font-sourcesans">
      <div className="max-w-md w-full bg-white rounded-xl border border-stone-200 shadow-md p-8 text-center">
        
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
        
        <h1 className="text-2xl font-playfair text-[#1c1917] mb-2">
          Order Confirmed!
        </h1>
        
        <p className="text-stone-500 mb-6">
          Thank you for your purchase. 
        </p>
        {/* A confirmation email has been sent to
          your email address with your order details. */}

        <div className="bg-[#f5f3ea] rounded-lg p-4 mb-6 text-sm text-stone-600">
          <p>Your order is being processed and will be shipped soon.</p>
          <p className="mt-2 text-xs text-stone-400">
            Reference: {sessionId?.substring(0, 20)}...
          </p>
        </div>

        <p className="text-xs text-stone-400 mb-6">
          70% of your purchase goes directly to people serving in Ukraine. 🇺🇦
        </p>

        <div className="flex flex-col gap-3">
          <Link
            to="/"
            className="w-full py-3 bg-[#BC3F4A] hover:bg-[#a3323b] text-white rounded-lg font-playfair transition"
          >
            Continue Shopping
          </Link>
          <Link
            to="/register"
            className="w-full py-3 border border-stone-300 text-stone-600 hover:bg-stone-50 rounded-lg transition text-sm"
          >
            Create an account to track orders
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GuestOrderSuccess;